const ImageFilterTypes = {
  BRIGHTNESS: 'brightness',
  CONTRAST:   'contrast',
  SATURATION: 'saturation',
  BLUR:       'blur',
  X_PROCESS:  'xProcess',
  VIGNETTE:   'vignette',
  TINT:       'tint',
  OPACITY:    'transparency',
};

ImageFilterTypes.Mixin = {
  created() {
    this.ImageFilterTypes = ImageFilterTypes;
  },
};
export default ImageFilterTypes;
